/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_ShelfInputs */

const en_blog_empty_shelf = /** @type {(inputs: Blog_Empty_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing on this shelf yet. The newest posts are one click away.`)
};

const pl_blog_empty_shelf = /** @type {(inputs: Blog_Empty_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na tej półce jeszcze nic nie ma. Najnowsze wpisy są o jedno kliknięcie stąd.`)
};

/**
* | output |
* | --- |
* | "Nothing on this shelf yet. The newest posts are one click away." |
*
* @param {Blog_Empty_ShelfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_empty_shelf = /** @type {((inputs?: Blog_Empty_ShelfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_ShelfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_empty_shelf(inputs)
	return en_blog_empty_shelf(inputs)
});